/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { HTTPValidationError } from "./HTTPValidationError.ts";
import type { WalletLeaderboard } from "./WalletLeaderboard.ts";

export const getWalletLeaderboardV1StatsLeaderboardWalletsGetQueryParamsNetworkEnum =
	{
		REGTEST: "REGTEST",
		MAINNET: "MAINNET",
	} as const;

export type GetWalletLeaderboardV1StatsLeaderboardWalletsGetQueryParamsNetworkEnum =
	(typeof getWalletLeaderboardV1StatsLeaderboardWalletsGetQueryParamsNetworkEnum)[keyof typeof getWalletLeaderboardV1StatsLeaderboardWalletsGetQueryParamsNetworkEnum];

export type GetWalletLeaderboardV1StatsLeaderboardWalletsGetQueryParams = {
	/**
	 * @type string
	 */
	network: GetWalletLeaderboardV1StatsLeaderboardWalletsGetQueryParamsNetworkEnum;
	/**
	 * @minLength 1
	 * @maxLength 100
	 * @default 25
	 * @type integer | undefined
	 */
	limit?: number;
};

/**
 * @description Successful Response
 */
export type GetWalletLeaderboardV1StatsLeaderboardWalletsGet200 =
	WalletLeaderboard;

/**
 * @description Validation Error
 */
export type GetWalletLeaderboardV1StatsLeaderboardWalletsGet422 =
	HTTPValidationError;

export type GetWalletLeaderboardV1StatsLeaderboardWalletsGetQueryResponse =
	GetWalletLeaderboardV1StatsLeaderboardWalletsGet200;

export type GetWalletLeaderboardV1StatsLeaderboardWalletsGetQuery = {
	Response: GetWalletLeaderboardV1StatsLeaderboardWalletsGet200;
	QueryParams: GetWalletLeaderboardV1StatsLeaderboardWalletsGetQueryParams;
	Errors: GetWalletLeaderboardV1StatsLeaderboardWalletsGet422;
};
